import { BookingStatus, ResourceRefType, type Booking } from '../../../models/Scheduling'

export const reschedulePath = (bookingId: string) => `/scheduling/reschedule/${bookingId}`

export const bookingTabPath: Record<BookingStatus, string> = {
  [BookingStatus.OPPORTUNITY]: '/scheduling/suggested',
  [BookingStatus.REQUESTED]: '/scheduling/requests',
  [BookingStatus.AWAITING_REPLY]: '/scheduling/waiting',
  [BookingStatus.CONFIRMED]: '/scheduling/scheduled',
  [BookingStatus.CANCELLED]: '/scheduling/cancelled',
}

export const scheduledTabPath = bookingTabPath[BookingStatus.CONFIRMED]

export const requestsTabPath = bookingTabPath[BookingStatus.REQUESTED]

export const schedulingSetupPath = '/workspace/setup/scheduling'

export const accountBookingPagePath = `${schedulingSetupPath}/account-booking-page`

export type EventTypeEditorTab = 'availability' | 'hosts' | 'details'

export const eventTypeEditorPath = (eventTypeId: string, tab: EventTypeEditorTab) => `${schedulingSetupPath}/scheduling-event-type/edit/${eventTypeId}/${tab}`

export const meetingPrepPath = (roomId: string, sessionId: string) => `/workspace/upcoming/room/${roomId}/session/${sessionId}/`

export const pastMeetingPath = (roomId: string, sessionId: string) => `/workspace/past-meetings/room/${roomId}/session/${sessionId}/`

export interface MeetingPrepIds {
  roomId: string
  sessionId: string
}

export const getMeetingPrepIds = (booking: Booking): MeetingPrepIds | undefined => {
  if (!booking.room || !booking.session) {
    return undefined
  }
  const roomId = booking.session.ids.roomId ?? booking.room.ids.roomId
  const sessionId = booking.session.ids.sessionId
  if (!roomId || !sessionId) {
    return undefined
  }
  return { roomId, sessionId }
}

export const getSourceMeetingIds = (booking: Booking): MeetingPrepIds | undefined => {
  if (booking.source?.type !== ResourceRefType.SESSION) {
    return undefined
  }
  const { roomId, sessionId } = booking.source.ids
  if (!roomId || !sessionId) {
    return undefined
  }
  return { roomId, sessionId }
}
